// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { CollateralAgreement as CollateralAgreementV2 } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useCollateralAgreementsV2: () => UseQueryResult<
  TemplateContract<CollateralAgreementV2>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data || '';
  return useQueryWithOffset({
    queryKey: ['queryCollateralAgreementsV2', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      return ledgerApi.queryCollateralAgreementsV2(offset, operator);
    },
  });
};
